export default "__VITE_ASSET__b80ee849__"